import { Component, OnInit, Input, Inject, OnDestroy } from '@angular/core';
import { ObservablesService } from '../observables.service';
import { ApiService } from '../api.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Subject } from "rxjs";
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  action:boolean;
  message:any;
  data:any;
}
@Component({
  selector: 'app-admin-sidenav',
  templateUrl: './admin-sidenav.component.html',
  styleUrls: ['./admin-sidenav.component.scss']
})
export class AdminSidenavComponent implements OnInit {
  loggedUserInfo:any=[];
  closeResult: string;
  h_level:any=[];
  productDetails:any=[];
  profileUpdateSubscriber:any
  iterateSubscriber:any;
  iterationObserver:any = new Subject<any>();
  iterateSubscriber1:any;
  iterationObserver1:any = new Subject<any>();
  iterateSubscriber2:any;
  iterationObserver2:any = new Subject<any>();
  iterateSubscriber3:any;
  iterationObserver3:any = new Subject<any>();
  iterateSubscriber4:any;
  iterationObserver4:any = new Subject<any>();
  iterateSubscriber5:any;
  iterationObserver5:any = new Subject<any>();
  constructor(private datePipe:DatePipe,public dialog: MatDialog,private router:Router,private api:ApiService, private observables:ObservablesService,private modalService: NgbModal,private fb:FormBuilder) { }
  ngOnDestroy(){
    this.profileUpdateSubscriber.unsubscribe()
  }
  ngOnInit() {
    this.profileUpdateSubscriber = this.observables.profileUpdateStatus.subscribe(()=>{
      this.api.getLoggedUserInfo().then((res:any)=>{

        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];

        }else{
          this.api.logOut()
        }
      })
    })
    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log("res=",res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];

      }else{
        this.api.logOut()
      }
    })
  }

  closeMenu(){
    // console.log('called me')
    this.observables.setMenuStatus({menuState:'out'})
  }

  profile(){
    this.closeMenu();
    let dialogConfig:any;

      dialogConfig = {
        panelClass: 'profile-popup',
        width: '50vw',
        height: '80vh',
        data: {action:true,data:this.loggedUserInfo,message:"Admin Profile"}
      }

   const dialogRef = this.dialog.open(AdminProfileComponent,dialogConfig);

   dialogRef.afterClosed().subscribe(result => {
     // console.log(`Dialog result: ${result}`);

   });
  }

  addUser(){
    this.closeMenu();
    this.router.navigate(['/admin/add-user'])
  }
  addItem(){
    this.closeMenu();
    this.router.navigate(['/admin/add-item'])
  }

  addTags(){
    this.closeMenu();
    this.observables.tagPopupStatus.next()
  }

  logOut(){
    this.closeMenu();
    localStorage.clear();
    localStorage.setItem("logOutStatus",'1')
    // this.observables.logout();
    this.router.navigate(['/admin/login']);
  }

  setPreferences(){
    this.closeMenu();

    this.router.navigate(['/admin/preferences'])
  }



  changePassword(){
    this.closeMenu();

    this.observables.changePasswordStatus.next()
  }


  gotoReport(){
    this.closeMenu();
    // this.observables.setPage({page:'report',data:{}});
  }

  addRole(){
    this.closeMenu();
    this.router.navigate(['/admin/add-role']);
  }

  mergeOldInvoices(){
    this.closeMenu();
    this.api.send('findDb',{
      fields:["S.*,S.id as invoice_id"],
      table:"invoices as S",
      conditions:[{"S.slip_status":1}]
    }).then((res:any)=>{
      // console.log("total invoices==",res)
      this.getMasterSlips(res.data).then((res1:any)=>{
        // console.log("--------------------- Task completed ! --------------------")
      })

    })
  }

  getMasterSlips(data){
    return new Promise((resolve)=>{

      let k=0;

      this.iterateSubscriber5 = this.iterationObserver5.subscribe((k)=>{
        if(k>=data.length){
          this.iterateSubscriber5.unsubscribe()
          resolve(true)
        }else{
          this.api.send("findDb",{
            table:"master_slips",
            conditions:[{invoice_id:data[k].invoice_id}]
          }).then((result:any)=>{
            // console.log("master k ==",k)
            // console.log("master product details result=",result.data)
            this.saveInvoiceData(result.data,data[k]).then((insertRes:any)=>{
              if(insertRes){

                this.iterationObserver5.next(k+1);
              }else{
                // console.log("something went wrong")
              }
            })

          })

        }
      })

      this.iterationObserver5.next(k)

    })
  }

  saveInvoiceData(value,data){
    return new Promise((resolve)=>{

      let date:any = new Date(data.invoice_date);
      // let invoice_date:any = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
      let invoice_date:any=this.datePipe.transform(date, 'yyyy-MM-dd');

      // console.log("value=",value)


      this.api.send("insertDb",{
        table:"master_invoices",
        data:{
          business_id:data.business_id,
          invoice_number:data.invoice_number,
          party_id:data.party_id,
          party_name:value[0].party_name,
          gstin:value[0].gstin,
          invoice_date:invoice_date,
          user_id:data.user_id,
          user_name:value[0].username,
          gst_total_amount:data.gst_total_amount,
          exclude_gst_total_amount: data.exclude_gst_total_amount,
          total_amount: data.total_amount,
          balance:data.balance,
          paid_status:data.paid_status,
          slip_status:data.slip_status,
          delete_status:data.delete_status,
          direct_invoice_status:data.direct_slip_status,
          tags:value[0].tags,
          note:value[0].note,
          delivery_to:value[0].delivery_to
        }
      }).then((result:any)=>{
        // console.log("result==",result)
        if(result.data.affectedRows){

          for(let i=0;i<value.length;i++)
          {

            this.api.send("updateDb",{
              table:"master_slips",
              data:{
                invoice_status:1,
                master_invoice_id:result.data.insertId
              },
              conditions:[{id:value[i].id}]
            }).then((result1:any)=>{
              // console.log("result=",result1)
              if(result1.data.affectedRows){
                if(value[0].direct_slip_status == 0){

                  this.updateProductDetails(value[i].id,result.data.insertId).then((productUpdateRes:any)=>{

                    if(i == value.length - 1){
                      resolve(true)
                    }

                  })
                }else{

                  if(i == value.length - 1){
                    resolve(true)
                  }

                }
              }else{

                this.api.send("deleteDb",{
                  table:"master_invoices",
                  conditions:[{id:result.data.insertId}]
                }).then((res1:any)=>{
                  if(i == value.length - 1){
                    resolve(true)
                  }
                })
              }
            })
          }
        }else{
          resolve(false)
        }
      })
    })


  }

  updateProductDetails(slip_id,invoice_id){
    return new Promise((resolve)=>{
      this.api.send("updateDb",{
        table:"master_slip_products",
        data:{
          master_invoice_id:invoice_id
        },
        conditions:[{master_slip_id:slip_id}]
      }).then((result1:any)=>{
        // console.log("result==",result1)
        resolve(true)

      })
    })
  }

  mergeOldSlips(){
    this.closeMenu();
    this.api.send('findDb',{
      fields:["S.*,PA.*,U.*,S.id as slip_id"],
      table:"slips as S",
      joins:[{
        type:"left",
        table:"parties as PA",
        conditions:["PA.id = S.party_id"]
      },{
        type:"left",
        table:"users as U",
        conditions:["U.id = S.user_id"]
      }]
    }).then((res:any)=>{
      // console.log("total slips==",res)
      this.getTags(res.data).then((finalRes:any)=>{
        // console.log("final product data = ",this.productDetails)
        this.saveMasterProductDetails()
      })

    })
  }

  getTags(data,slipStatus = true){
    return new Promise((resolve)=>{
      let k = 0;
      this.productDetails = []
      this.iterateSubscriber = this.iterationObserver.subscribe((k)=>{
        if(k>=data.length){
            this.iterateSubscriber.unsubscribe();
            resolve(true);
         }else{
           let condition = (slipStatus)?{"ST.slip_id":data[k].slip_id}:{"ST.invoice_id":data[k].invoice_id}
           this.api.send('findDb',{
             table:'slip_invoice_tags as ST',
             joins:[{
               type:'left',
               table:'tags as T',
               conditions:["T.id = ST.tag_id"]
             }],
             conditions:[condition]
           }).then((res:any)=>{
            // console.log("tags=",res)
            if(slipStatus){
              this.addToMaster(data[k],res.data).then((resp:any)=>{
                if(resp.status){
                  this.productDetails.push({master_slip_id:resp.master_slip_id,categories:[]})
                  this.getCategories(data[k].slip_id).then((res1:any)=>{
                    // console.log("res111==",res1)
                    if(res1.length > 0){
                      this.productDetails[k].categories.push({category_name:res1[0].category_name,category_id:res1[0].id,products:[]})
                      this.getProducts(data[k].slip_id, this.productDetails[k].categories[0],data[k].gstin).then((res2:any)=>{

                        this.iterationObserver.next(k+1);
                      })
                    }else{
                      this.productDetails[k].categories.push({category_name:'',category_id:'',products:[]})
                      this.getProducts(data[k].slip_id, this.productDetails[k].categories[0],data[k].gstin).then((res2:any)=>{

                        this.iterationObserver.next(k+1);
                      })
                    }
                  })
                  // this.addToMasterProducts()
                }
              })
            }else{
              this.iterationObserver.next(k+1);
            }
           })

         }
      })

      this.iterationObserver.next(k);
    })
  }

  getCategories(slip_id=null){
    return new Promise((resolve)=>{

      this.api.send("findDb",{
        table:'categories',
        conditions:[{slip_id:slip_id}]
      }).then((res:any)=>{
        resolve(res.data)
      })
    })
  }

  getProducts(slip_id,category,gstin){
    return new Promise((resolve)=>{

      this.api.send("findDb",{
        fields:["P.*, I.*, U.*,P.rate as rate, I.name as item_name,U.name as unit_name, P.id as pd_id"],
        table:'product_details as P',
        joins:[
          {
            type:"left",
            table:"items as I",
            conditions:["I.id = P.item_id"]
          },{
            type:"left",
            table:"units as U",
            conditions:["U.id = I.unit_id"]
          }
        ],
        conditions:[{slip_id:slip_id}]
      }).then((res:any)=>{

        if(res.data.length > 0){
          for(let i=0; i<res.data.length;i++){
            let gst_amount = parseFloat(res.data[i].amount)/100*res.data[i].gst;
            category.products.push({
              product_detail_id:res.data[i].pd_id,
              item_id:res.data[i].item_id,
              item_name:res.data[i].item_name,
              item_code:res.data[i].item_code,
              gst:res.data[i].gst,
              cess:res.data[i].cess,
              item_description:res.data[i].description,
              rate:res.data[i].rate,
              unit:res.data[i].unit_name,
              discount:res.data[i].discount,
              gross_amount:parseFloat(res.data[i].amount),
              sgst:(this.loggedUserInfo.gstin.substring(0,2) == gstin.substring(0,2))?gst_amount/2:0,
              cgst:(this.loggedUserInfo.gstin.substring(0,2) == gstin.substring(0,2))?gst_amount/2:0,
              igst:(this.loggedUserInfo.gstin.substring(0,2) != gstin.substring(0,2))?gst_amount:0,
              net_amount:parseFloat(res.data[i].amount) + gst_amount,
              variables:[]
            })

            this.getUnitVariable(res.data[i].pd_id,res.data[i].unit_id,category.products[i]).then((arrayRes:any)=>{
              // console.log("arrayRes=",arrayRes)
              category.products[i].variables = arrayRes
              if(i == res.data.length - 1){
                resolve(true)
              }
            })
          }

        }else{
          resolve(true)
        }
      })
    })
  }

  getUnitVariable(pd_id,unit_id,products){
    return new Promise((resolve)=>{
      this.api.send("findDb",{
        table:"product_unit_variables as PU",
        joins:[{
          type:'left',
          table:"unit_variables as UV",
          conditions:["UV.id = PU.unit_variable_id"]
        }],
        conditions:[{"PU.product_detail_id":pd_id}]
      }).then((res:any)=>{
        // console.log("product variable ="+pd_id+"= res==",res.data)
        // console.log('productDetails===',this.productDetails)
        if(res.data.length > 0){

          let unit_value = 1
          for(let i=0;i<res.data.length;i++){

            products.variables.push({product_variable_id:res.data[i].product_detail_id,['col_'+(i+1)]:res.data[i].name,['col_'+(i+1)+'_value']:res.data[i].unit_variable_value})
            unit_value = unit_value * res.data[i].unit_variable_value
            if(i == res.data.length -1){
              products.unit_value = unit_value;
              resolve(products.variables)
              // setTimeout(()=>{
                //
                // },1000)
              }
            }
        }else{
          resolve(products.variables)
        }
      })
    })
  }




  addToMaster(value,slip_tags){
    let date:any = new Date(value.slip_date);
    let slip_date:any=this.datePipe.transform(date, 'yyyy-MM-dd');
    let tags = []
    if(slip_tags.length) {
      slip_tags.filter(item=>{
        // for(let i=0;i<this.tags.length;i++){
          // if(item == this.tags[i].id){
            tags.push({tag_id:item.tag_id,tag:item.tag_name})
          //   break;
          // }
        // }
      })
    }

    return new Promise((resolve)=>{
      this.api.send("insertDb",{
        table:"master_slips",
        data:{
          business_id:value.business_id,
          slip_id:value.slip_id,
          invoice_id:value.invoice_id,
          slip_number:value.slip_number,
          party_id:value.party_id,
          party_name:value.business_name,
          gstin:value.gstin,
          slip_date:slip_date,
          user_name:value.full_name,
          total_amount: value.total_amount,
          invoice_status:value.invoice_status,
          gst_total_amount:value.gst_total_amount,
          direct_slip_status:value.direct_slip_status,
          delivery_to: value.delivery_to,
          note:value.note,
          user_id:value.user_id,
          tags:(tags.length)?JSON.stringify(tags):null
        }
      }).then((result:any)=>{
        // console.log("master result=",result)
        if(result.data.affectedRows){
          resolve({status:true,master_slip_id:result.data.insertId});
        }else{
          resolve({status:false});

        }
      })
    })
  }

  saveMasterProductDetails(){
    let k = 0;
    this.iterateSubscriber1 = this.iterationObserver1.subscribe((k)=>{
      if(k>=this.productDetails.length){
          this.iterateSubscriber1.unsubscribe();

       }else{
         this.prepareMasterProductDetails(this.productDetails[k]).then((res:any)=>{
           // console.log("Prepared data==",res)
           if(res.length > 0){
             this.saveData(res).then(res=>{

               this.iterationObserver1.next(k+1)
             })

           }else{
             this.iterationObserver1.next(k+1)
           }
         })
       }
     })

     this.iterationObserver1.next(k)

  }

  saveData(data){
    // console.log("master Data prepared=",data)
    return new Promise((resolve)=>{

      let k=0;

      this.iterateSubscriber5 = this.iterationObserver5.subscribe((k)=>{
        if(k>=data.length){
          this.iterateSubscriber5.unsubscribe()
          resolve(true)
        }else{
          this.api.send("insertDb",{
            table:"master_slip_products",
            data:data[k]
          }).then((result:any)=>{
            // console.log("master product details result=",result)
            // if(result.data.affectedRows){
            //   resolve(true);
              this.iterationObserver5.next(k+1);
            // }else{
            //   resolve(false);
            //
            // }
          })

        }
      })

      this.iterationObserver5.next(k)

    })
  }


  prepareMasterProductDetails(masterSlip){
    // console.log("preparing=",this.productDetails)
    // return;
    return new Promise((resolve)=>{
      let k=0;
      let data = []
      this.iterateSubscriber2 = this.iterationObserver2.subscribe((k)=>{
        if(k>=masterSlip.categories.length){
          this.iterateSubscriber2.unsubscribe()
          resolve(data)
        }else{
          masterSlip.categories[k].master_slip_id = masterSlip.master_slip_id;
          if(masterSlip.categories[k].products.length > 0){
            this.getProductDetails(masterSlip.categories[k].products).then((res:any)=>{
              delete masterSlip.categories[k].products
              // console.log("ccc=",masterSlip.categories[k])
              // console.log("rrr=",res)
              for(let i=0;i<res.length;i++){
                data.push(this.prepareObject([masterSlip.categories[k],res[i]]))
                if(i == res.length - 1){

                  this.iterationObserver2.next(k+1);
                }
              }
              // console.log("saddsad=",this.prepareObject([this.productDetails[0].categories[k],res[0]]))
              // data.push(this.prepareObject([this.productDetails[0].categories[k],res[0]]))
            })

          }else{
            delete masterSlip.categories[k].products
            this.iterationObserver2.next(k+1);
          }
        }
      })

      this.iterationObserver2.next(k)

    })
  }



  getProductDetails(products){

    return new Promise((resolve)=>{
      let k=0;
      let productArr = []
      this.iterateSubscriber3 = this.iterationObserver3.subscribe((k)=>{
        if(k>=products.length){
          this.iterateSubscriber3.unsubscribe()
          resolve(productArr)
        }else{

          this.getVariableDetails(products[k].variables).then((res3:any)=>{
            delete products[k].variables;
            productArr.push(this.prepareObject([products[k],res3]))
            this.iterationObserver3.next(k+1);
          })
        }
      })

      this.iterationObserver3.next(k)
    })

  }

  getVariableDetails(variables){
    // console.log("variables===",variables)
    return new Promise((resolve)=>{
      let k=0;
      let unit_variables = []
      this.iterateSubscriber4 = this.iterationObserver4.subscribe((k)=>{
        if(k>=variables.length){
          this.iterateSubscriber4.unsubscribe()
          resolve(this.prepareObject(unit_variables))
        }else{
          unit_variables.push(variables[k])
          this.iterationObserver4.next(k+1);

        }
      })

      this.iterationObserver4.next(k)
    })
  }

  prepareObject(arr){
    return arr.reduce(function(result, currentObject) {
        for(var key in currentObject) {
            if (currentObject.hasOwnProperty(key)) {
                result[key] = currentObject[key];
            }
        }
        return result;
    }, {});
  }
}


@Component({
  selector: 'app-profile',
  templateUrl: '../profile/profile.component.html'
})
export class AdminProfileComponent {
  profileData:any
  message:any
  profileForm:FormGroup;
  constructor(private observables:ObservablesService, private fb:FormBuilder, private api:ApiService,public dialog: MatDialog,public dialogRef: MatDialogRef<AdminProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    ngOnInit() {
      // console.log("data in profile dialog=",this.data)
      this.profileData = this.data.data;
      this.message = this.data.message
      this.profileForm = this.fb.group({
        business_id:[this.profileData.business_id, Validators.required],
        business_name:[{value:this.profileData.business_name,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        business_mobile:[{value:this.profileData.business_mobile,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        address:[{value:this.profileData.address,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        city:[{value:this.profileData.city,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        state:[{value:this.profileData.state,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        pincode:[{value:this.profileData.pincode,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        gstin:[{value:this.profileData.gstin,disabled:(this.profileData.role == 'ADMIN')?false:true}, Validators.required],
        full_name:[this.profileData.full_name, Validators.required],
        mobile:[this.profileData.mobile, Validators.required],
      })
    }

    save(){

      let value = this.profileForm.getRawValue();
      // console.log("value==",value)
      if(this.profileData.role == 'ADMIN'){

        if(value.business_name != this.profileData.business_name || value.business_mobile != this.profileData.business_mobile ||
          value.address != this.profileData.address || value.city != this.profileData.city ||
          value.state != this.profileData.state || value.pincode != this.profileData.pincode || value.gstin != this.profileData.gstin
        ){
          // console.log("in admin if")
          //update business
          if(confirm("Are you sure to update business details ?")){
            this.updateBusinessData(value);

            if(value.mobile != this.profileData.mobile || value.full_name !=this.profileData.full_name){
              //update user
              if(confirm("Are you sure to update profile details?")){

                this.updateUserData(value)
              }
            }
          }
        }else if(value.mobile != this.profileData.mobile || value.full_name !=this.profileData.full_name){
          //update user
          // console.log("in admin else if")
          if(confirm("Are you sure to update profile details ?")){
            this.updateUserData(value)
          }
        }else{
          //no changes
          this.observables.showToastMessage({type:0,message:"No changes Detected"})
        }

      }else{

        if(value.mobile != this.profileData.mobile || value.full_name !=this.profileData.full_name){


          if(confirm("Are you sure to update profile details ?")){

            this.updateUserData(value)

          }

        }else{
          this.observables.showToastMessage({type:0,message:"No changes Detected"})
        }
      }

    }

    updateUserData(value){
      this.api.send("updateDb",{
        table:"users",
        data:{
          full_name:value.full_name,
          mobile:value.mobile
        },
        conditions:[{id:this.profileData.id,business_id:this.profileData.business_id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0,message:"Profile Updated"})
          this.dialogRef.close()
          this.observables.profileUpdateStatus.next()
        }else{

          this.observables.showToastMessage({type:1,message:"Some Problem Occured, Profile Not Updated"})
        }
      })
    }
    updateBusinessData(value){
      this.api.send("updateDb",{
        table:"businesses",
        data:{
          name:value.business_name,
          mobile:value.business_mobile,
          gstin:value.gstin,
          address:value.address,
          city:value.city,
          state:value.state,
          pincode:value.pincode
        },
        conditions:[{id:this.profileData.business_id}]
      }).then((res:any)=>{
        if(res.data.affectedRows){

          this.observables.showToastMessage({type:0,message:"Business details Updated"})
          this.dialogRef.close()
          this.observables.profileUpdateStatus.next()
        }else{

          this.observables.showToastMessage({type:1,message:"Some Problem Occured, Business details Not Updated"})
        }
      })
    }
  }
